import { Component, Input } from '@angular/core';

const colorPattern = "^#(?:[0-9a-fA-F]{3}){1,2}$";
const pattern = new RegExp(colorPattern, 'i');

@Component({
  selector: 'atn-color-input',
  templateUrl: './color-input.component.html',
  styleUrls: ['./color-input.component.scss'],

})
export class ColorInputComponent {

  @Input() color: any;

  get value() {
    return pattern.test(this.color) ? this.color : 'transparent';
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/color-input/color-input.component.ts